import React from "react";
import Box from "@mui/material/Box";
import { BiTime } from "react-icons/bi";
import moment from "moment";

export interface Props {
  dateTime: Date;
  timeZone?: string;
}

const classes = {
  cardContentItem: {
    display: "flex",
    alignItems: "center",
    fontSize: "14px",
    lineHeight: 1,
  },
} as const;

const EventStartTime = ({ dateTime, timeZone }: Props) => {
  return (
    <Box sx={classes.cardContentItem}>
      <BiTime
        style={{ marginRight: "10px", color: "#A8A8A8", fontSize: "16px" }}
      />
      {moment(dateTime).format("hh:mm")} {timeZone && `(${timeZone})`}
    </Box>
  );
};

export default EventStartTime;
